import {
  datasetLabelPresetColors,
  type DatasetLabelColorOption,
  type DatasetLabelColorOptionName,
} from '@/modules/Datasets/datasetLabelTypes'

/**
 * Get the matching text color for a given background color
 * @param color - The background color of the label
 * @returns The matching text color for the label
 */
export const getMatchingTextColor = (color: string): string | undefined =>
  datasetLabelPresetColors.find((p) => p.bgColor === color)?.textColor

/**
 * Get a random preset color
 * @returns A random preset color
 */
export const getRandomPresetColor = (): DatasetLabelColorOption =>
  datasetLabelPresetColors[Math.floor(Math.random() * datasetLabelPresetColors.length)]

/**
 * Get a preset color by name
 * @param name - The name of the preset color
 * @returns The preset color
 */
export const getPresetColorByName = (
  name: DatasetLabelColorOptionName,
): DatasetLabelColorOption | undefined => datasetLabelPresetColors.find((p) => p.name === name)
